import type {PayloadAction} from '@reduxjs/toolkit';

export type Store = {
  user?: AppUser,
  active: boolean,
  loaded: boolean,
  revision: number,
  notifications: number,
}

export type Actions = {
  Start: PayloadAction<{}>
  Revision: PayloadAction<{}>
  Login: PayloadAction<AppUser>
  Activate: PayloadAction<{active: boolean}>
  Load: PayloadAction<{loaded: boolean}>
  Notify: PayloadAction<{count: number}>
}

export type AppUser = {
  ekey: string,
  name?: string,
  email?: string,
  avatar: string,
  created: string,
  options: number,
  header: AppHeader,
  group: AppUserGroup,
  limit: AppUserLimit,
}

export type AppHeader = {
  custom: boolean,
  logo: string,
  theme: {
    header: string,
  },
  colors: {
    header: string,
    primary: string,
  },
  business: {
    company: string,
    subdomain: string,
  }
}

export type AppUserLimit = {
  storage: {
    used: number,
    total: number,
  }
}

export enum AppUserGroup {
  Unregistered,
  Trial,
  Free,
  Pro,
  Business,
}
